module.exports = __webpack_public_path__ + "static/img/data-money-bg.15a9d27c.png";